import { render, staticRenderFns } from "./Geo.vue?vue&type=template&id=4428dec8&scoped=true&"
import script from "./Geo.vue?vue&type=script&lang=ts&"
export * from "./Geo.vue?vue&type=script&lang=ts&"
import style0 from "./Geo.vue?vue&type=style&index=0&id=4428dec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428dec8",
  null
  
)

export default component.exports